import React from "react";
import useGlobalStore from "../stores/globalStore";

export default function DigiCardInput() {
  //Store
  const digiCardAmount = useGlobalStore((state) => state.digiCardAmount);
  const setDigiCardAmount = useGlobalStore((state) => state.setDigiCardAmount);

  //Functions
  const handleDigiCardAmount = (clickType) => {
    if (digiCardAmount === 10 && clickType === "plus") return;
    if (clickType === "plus") {
      setDigiCardAmount(digiCardAmount + 1);
    }

    if (digiCardAmount === 0 && clickType === "minus") return;
    if (clickType === "minus") {
      setDigiCardAmount(digiCardAmount - 1);
    }
  };

  return (
    <div className="tel-pt-digi-card">
      <div className="tel-pt-digi-card__info">
        <h4>Programkort</h4>
        <p>35kr per stk /mån</p>
      </div>
      <div className="tel-pt-digi-card-input">
        <button className="tel-pt-digi-card-input__button" type="button" onClick={() => handleDigiCardAmount("minus")}>
          -
        </button>
        <p className="tel-pt-digi-card-input__amount">{digiCardAmount}</p>
        <button className="tel-pt-digi-card-input__button" type="button" onClick={() => handleDigiCardAmount("plus")}>
          +
        </button>
      </div>
    </div>
  );
}
